/**
 * @file: PlanFilterBar.tsx
 *
 * Always-visible top bar for the plans timeline: a plate search box plus a
 * 筛选 button (badged when extra filters are active) that opens the filter
 * panel. Plate commits on submit; the rest is applied from the panel.
 */

import { SearchBar } from '@euler/app/components/SearchBar';
import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { SlidersHorizontal } from 'lucide-react-native';
import { FC, memo } from 'react';
import { TouchableOpacity, View } from 'react-native';

export const PlanFilterBar: FC<{
  searchText: string;
  activeFilterCount: number;
  onSearchChange: (text: string) => void;
  onSearchSubmit: (text: string) => void;
  onOpenFilters: () => void;
}> = memo(
  ({
    searchText,
    activeFilterCount,
    onSearchChange,
    onSearchSubmit,
    onOpenFilters,
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View
        css={`
          flex-direction: row;
          align-items: center;
          padding: ${rpx(8)}px ${rpx(12)}px;
          gap: ${rpx(10)}px;
          background-color: #eee;
        `}
      >
        <SearchBar
          searchInputEditable
          searchText={searchText}
          searchPlaceholder="搜索车牌号 / 保养项目"
          onSearchInputChange={onSearchChange}
          onSearch={onSearchSubmit}
          style={{ flex: 1 }}
        />
        <TouchableOpacity
          onPress={onOpenFilters}
          activeOpacity={0.7}
          css={`
            flex-direction: row;
            align-items: center;
            height: ${rpx(36)}px;
            padding: 0 ${rpx(12)}px;
            border-radius: ${rpx(18)}px;
            background-color: #fff;
          `}
        >
          <SlidersHorizontal size={rpx(15)} color="#374151" />
          <Typography.Text size={rpx(13)} color="#374151" ml={rpx(6)}>
            筛选
          </Typography.Text>
          {activeFilterCount > 0 ? (
            <View
              css={`
                margin-left: ${rpx(5)}px;
                min-width: ${rpx(16)}px;
                height: ${rpx(16)}px;
                padding: 0 ${rpx(4)}px;
                border-radius: ${rpx(8)}px;
                align-items: center;
                justify-content: center;
                background-color: #1f80ff;
              `}
            >
              <Typography.Text size={rpx(10)} color="#fff" medium>
                {activeFilterCount}
              </Typography.Text>
            </View>
          ) : null}
        </TouchableOpacity>
      </View>
    );
  },
);
